import { canRead, canWrite } from '../access/rbacAccess'

export const ASSETS = {
  REPORTS: 'ejecuta.reports_asset',
  CLOSE: 'ejecuta.close_asset'
}

export const canViewAssetReports = () => canRead(ASSETS.REPORTS)

export const canManageAssetReports = () => canWrite(ASSETS.REPORTS)

export const canViewCloseAssets = () => canRead(ASSETS.CLOSE)

export const canManageCloseAssets = () => canWrite(ASSETS.CLOSE)
